
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#D5DBE3"}},[_c('circle',{attrs:{"cx":"1","cy":"1","r":"1"}}),_c('circle',{attrs:{"cx":"6","cy":"1","r":"1"}}),_c('circle',{attrs:{"cx":"1","cy":"6","r":"1"}}),_c('circle',{attrs:{"cx":"6","cy":"6","r":"1"}}),_c('circle',{attrs:{"cx":"1","cy":"11","r":"1"}}),_c('circle',{attrs:{"cx":"6","cy":"11","r":"1"}})])])
          )
        }
      }
    